import './SearchForm.scss';
import './ResultPageBrowser/ResultPageBrowser.scss';
